import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";

import { firebase, firebase2 } from 'components/Firebase/firebase';
//import firebase2 from 'components/Firebase/firebase2';
import { useTranslation } from 'react-i18next';

// @material-ui/core components
import Divider from '@material-ui/core/Divider';
import Fab from '@material-ui/core/Fab';

// @material-ui/icons
// core components
import Header from "components/header/header.js";
import GridContainer from "components/grid/gridContainer.js";
import GridItem from "components/grid/gridItem.js";

import AssetsSection from 'views/components/assetsSection';
import TimeAvailableChart from 'views/components/timeAvailableChart';
import Typography from '@material-ui/core/Typography';
import Fade from '@material-ui/core/Fade';
import CircularProgress from '@material-ui/core/CircularProgress';
import SupportedConsolesSection from 'views/components/supportedConsolesSection';
import i18n from 'i18n';
import Tour from 'reactour';
import CustomHelper from 'components/tooltip/customHelper';
import { useTheme } from '@material-ui/core/styles';
import jss from 'jss';
import rtl from 'jss-rtl';
import ChatIcon from 'components/icons/chatIcon';
import FeedbackModal from 'views/components/feedbackModal';
import BadWidgetModal from 'views/components/badWidgetModal';
import facilityViewStyle from 'assets/jss/views/facilityView'
import ReactGA from 'react-ga';

const dashboardRoutes = [];

function FacilityView(props) {
    let widgetId = props.match.params.widgetId;
    const classes = facilityViewStyle();
    const { changeColor, ...rest } = props;
    const [facData, setFacData] = useState({});
    const [token, setToken] = useState("");
    const [authenticated, setAuthenticated] = useState(false);
    const [assetsList, setAssetsList] = useState([]);
    const [firebase1Assets, setfirebase1Assets] = useState([]);
    const [firebase2Assets, setfirebase2Assets] = useState([]);
    const [facId, setFacId] = useState("");
    const [uid, setUid] = useState("");
    const [errorDialog, setErrorDialog] = useState(false);
    const [isTourOpen, setIsTourOpen] = useState(!localStorage.getItem('guidedTourWidget' + widgetId) || false);
    const { t } = useTranslation();
    const [renderComponentsBig, setRenderComponentsBig] = useState(window.innerWidth > 960);
    const guidedTour = {
        steps: [
            {
                selector: '.step1-guidedTour',
                content: t('onboardingSupportMessage'),
                style: {
                    backgroundColor: '#fff',
                },
            },
            {
                selector: '.step2-guidedTour',
                content: t('onboardingAvailabilityMessage'),
                style: {
                    backgroundColor: '#fff',
                },
            },
        ]
    };
    const [openFeedback, setOpenFeedback] = useState(false);
    const [chartData, setChartData] = useState({});
    const [logo, setLogo] = useState(null);
    const [assetSpinner, setAssetSpinner] = useState(false);
    const [showCustom, setShowCustom] = useState(false);
    //RTL support

    //Run GA pageview just once (as componentDidMount)
    useEffect(() => {
        ReactGA.pageview(window.location.pathname + window.location.search);
    }, []);


    const saveCookiesAsVisited = (event) => {
        setIsTourOpen(false);
        if (widgetId) {
            localStorage.setItem('guidedTourWidget' + widgetId, true);
        }
    };

    useEffect(() => {
        firebase.database().ref('WIDGET/' + widgetId).on("value", function (snapshot) {
            if (!snapshot.exists()) {
                setIsTourOpen(false);
                setErrorDialog(true);
                setShowCustom(true);
                return;
            }
            setFacId(Object.keys(snapshot.val().facId)[0]);
            setUid(snapshot.val().managerId);
            setAssetSpinner(true);
            if (snapshot.val().language) {
                i18n.changeLanguage(snapshot.val().language);
                if (i18n.dir(snapshot.val().language) === 'rtl')
                    jss.use(rtl());
            }
            if (snapshot.val().fontColor) {
                if (checkHex(snapshot.val().fontColor))
                    changeColor(snapshot.val().fontColor);
                else {
                    console.log('invalid hex color');
                }
            }
            else {
                changeColor('#d11f2e');
            }
            setLogo(snapshot.val().logo ? snapshot.val().logo : null);
            setShowCustom(true);
        });
    }, [widgetId]);

    function checkHex(value) {
        return /^#([A-Fa-f0-9]{3}$)|([A-Fa-f0-9]{6}$)/.test(value)
    }

    useEffect(() => {
        if (facId && uid) {
            let url = process.env.REACT_APP_FIREBASE_CREATETOKEN + '?facId=' + facId + '&uid=' + uid + '&key=' + process.env.REACT_APP_FIREBASE_CREATETOKEN_KEY;
            fetch(url,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                        // 'Content-Type': 'application/x-www-form-urlencoded',
                    },
                })
                .then(response => {
                    return response.text();
                }).then(data => {
                    setToken(data);
                });
        }
    }, [facId, uid]);

    useEffect(() => {
        if (token === "") return;
        firebase.auth().signInWithCustomToken(token).then(() => {
            setAuthenticated(true);
        }).catch(function (error) {
            console.log(error);
        });
    }, [token]);

    useEffect(() => {
        if (!authenticated || facId === "") return;
        firebase.database().ref('FACILITY_INFO/' + facId).once("value", function (snapshot) {
            setFacData(snapshot.val());
        }).catch((err) => {
            console.log(err);
        });
    }, [authenticated, facId]);

    //get graph data. TODO correct day of the week.
    useEffect(() => {
        if (facId === "" || !authenticated || Object.keys(facData).length === 0) return;
        firebase.database().ref('RTWAnalytics/' + parseInt(facId, 10) + "/0").once("value", function (snapshot) {
            if (!snapshot.exists())
                return;
            //console.log(snapshot.val());
            var chartDataToSend = snapshot.val();
            chartDataToSend.facilityStartTime = facData.facilityStartTime;
            chartDataToSend.facilityEndTime = facData.facilityEndTime;
            chartDataToSend.timezone = facData.timezone;
            setChartData(chartDataToSend);
        }).catch((err) => {
            console.log(err);
        });
    }, [facId, authenticated, facData]);

    //Get Assets from Service Notices
    useEffect(() => {
        if (facId === "" || !authenticated) return;
        firebase.database().ref('ASSETS').orderByChild('facId').equalTo(parseInt(facId, 10)).on("value", function (snapshot) {
            let newList = [];
            snapshot.forEach(element => {
                var assetTypeString = getActivityName(element.val().assetType);
                let newElem = element.val();
                newElem.type = assetTypeString;
                newList.push(newElem);
            });
            ///console.log(newList);
            setfirebase1Assets(newList);
        });
    }, [facId, authenticated]);

    //Get assets from aquaman
    useEffect(() => {
        if (facId !== '')
            firebase2.database().ref('assets').orderByChild('facility_id').equalTo(parseInt(facId, 10)).on("value", function (snapshot) {
                let newList = [];
                snapshot.forEach(element => {
                    let newElem = element.val();
                    newElem.bodySerial = element.key;
                    newList.push(newElem);
                });
                setfirebase2Assets(newList);
            });/*.catch((err) => {
                console.log(err);
            });*/
    }, [facId]);

    //When assets from aquman and service notices, then merge
    useEffect(() => {
        if (firebase1Assets.length > 0 && firebase2Assets.length > 0) {
            var finalList = [];
            //var uniqueConsoleTypes = [];
            var allowedConsoleType = ["Discover SE3 HD", "Discover SE3", "Discover SE", "Discover SI", "ST", "70T", "Integrity SL"];

            //merge assets
            firebase1Assets.forEach(asset => {
                if (allowedConsoleType.indexOf(asset.consoleType) > -1) {
                    var elem = firebase2Assets.find(el => el.bodySerial === asset.bodySerial);
                    if (elem !== undefined) {
                        var newObj = asset;
                        Object.keys(elem).forEach(key => newObj[key] = elem[key]);
                        finalList.push(newObj);
                    }
                }
            });
            setAssetsList(groupAssetsByActivityName(finalList));
            setAssetSpinner(false);
        }
    }, [firebase1Assets, firebase2Assets]);

    function groupAssetsByActivityName(assets) {
        let newList = [];
        assets.forEach(element => {
            if (element.type !== "") {
                if (newList.find(x => x.type === element.type)) {
                    newList.find(x => x.type === element.type).assets.push(element);
                }
                else {
                    let newInnerObj = {};
                    newInnerObj.assets = [];
                    newInnerObj.type = element.type;
                    newInnerObj.assets.push(element);
                    newList.push(newInnerObj);
                }
            }
        });
        //Order all list
        const consoleOrder = ["Discover SE3 HD", "Discover SE3", "Discover SE", "Discover SI", "ST", "70T", "Integrity SL"];
        const assetOrder = ["treadmills", "crossTrainers", "uprightBikes", "recumbentBikes", "powermills", "flexstriders", "arcTrainers"];

        newList.forEach(element => {
            element.assets.sort((a, b) => consoleOrder.indexOf(a.consoleType) - consoleOrder.indexOf(b.consoleType));
        });
        newList.sort((a, b) => assetOrder.indexOf(a.type) - assetOrder.indexOf(b.type));
        return newList;
    }

    function getActivityName(assetType) {
        switch (assetType) {
            case 1:
            case 5:
            case 8:
            case 9:
            case 14:
            case 28: return "treadmills";
            case 2: return "uprightBikes";
            case 3: return "recumbentBikes";
            case 4: return "crossTrainers";
            case 7: return "crossTrainers";
            case 11: return "crossTrainers";
            case 15: return "flexstriders";
            case 16: return "powermills";
            case 18: return "gscTrainers";
            case 19: return "arcTrainers";
            default: return "";
        }
    }

    useEffect(() => {
        function handleResize() {
            if (window.innerWidth > 960)
                setRenderComponentsBig(true)
            else
                setRenderComponentsBig(false);
        }
        window.addEventListener('resize', handleResize);

        return _ => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    const handleOpenFeedback = () => {
        setOpenFeedback(true);
    };

    const handleCloseFeedback = () => {
        setOpenFeedback(false);
    };

    const theme = useTheme();

    return (
        <div>
            { showCustom &&
                <React.Fragment>
                    <Tour
                        steps={guidedTour.steps}
                        isOpen={isTourOpen}
                        onRequestClose={saveCookiesAsVisited}
                        accentColor={theme.palette.primary.main}
                        closeWithMask={false}
                        disableInteraction={true}
                        CustomHelper={CustomHelper}
                    />
                    <Header
                        color="white"
                        routes={dashboardRoutes}
                        brand="Halo"
                        facilityName={facData.facName}
                        logo={logo}
                        {...rest}
                    />
                    <GridContainer className={classes.subheader}>
                        <GridItem xs={12} sm={12} md={12}>
                            <Typography>
                                {facData.facName}
                            </Typography>
                        </GridItem>
                    </GridContainer>
                    <Divider className={classes.responsive} />
                    <GridContainer >
                        <GridItem xs={12} sm={12} md={4} className={classes.availableContainer}>
                            <TimeAvailableChart data={chartData} />
                            <Divider className={classes.responsive2} />
                            {renderComponentsBig ? <SupportedConsolesSection className={classes.supportedConsolesSectionContainerWhenSmall} /> : null}
                        </GridItem>
                        <GridItem xs={12} sm={12} md={8} className={classes.assetsSectionContainer}>
                            {renderComponentsBig ?
                                <div style={{ position: 'absolute', left: '60%', top: '30%', transform: 'translate(-50%, -50%)' }}>
                                    <Fade in={assetSpinner} unmountOnExit>
                                        <CircularProgress size='5rem' />
                                    </Fade>
                                </div>
                                : null}
                            <AssetsSection rows={assetsList} />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={8} className={classes.fillEmptySpace}>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={4} className={classes.supportedConsolesSectionContainerWhenBig}>
                            {renderComponentsBig ? null : <SupportedConsolesSection />}
                        </GridItem>
                    </GridContainer>
                    <Fab color="primary" aria-label="feedback" className={classes.floatingIcon} variant={renderComponentsBig ? "extended" : "round"} onClick={handleOpenFeedback}>
                        <ChatIcon className={classes.extendedIcon} />
                        {renderComponentsBig ? <div className={classes.feedbackText}>{t('feedback')}</div> : ""}
                    </Fab>
                    <FeedbackModal open={openFeedback} onClose={handleCloseFeedback} />
                    <BadWidgetModal open={errorDialog} />
                </React.Fragment>
            }
        </div>
    );
}

export default FacilityView;


FacilityView.propTypes = {
    changeColor: PropTypes.func.isRequired,
};